angular.module('impactx.toolbar').component('ixSearchFilterToggle', {
        controller: 'SearchFilterToggleCtrl',
        templateUrl: 'shared/toolbar/templates/search-filter-toggle.html'
    }
);